import { NestedUser } from "@habity/types";

export function buildSimpleUserAddress(user: NestedUser): string | null {
  const {
    address_street,
    address_zip,
    address_city,
  } = user || {};

  if (!address_street && !address_zip && !address_city) return null;

  const parts: string[] = [];

  if (address_street) parts.push(address_street);

  // Combine zip and city (e.g., "123 45 Stockholm")
  const zipCity = [address_zip, address_city].filter(Boolean).join(' ');
  if (zipCity) parts.push(zipCity);

  return parts.join(', ');
}
